import React, { Component } from "react";
// import Tarjetas from "./tarjetas";
// import scrollToComponent from "react-scroll-to-component";
import { Image, Row, Col } from "react-bootstrap";
import { Link } from "react-router-dom";

export default class nameClass extends Component {
  constructor(props) {
    super(props);
    this.state = {};
    this.routeParam = this.props.match.params;
  }
  componentWillMount() {}
  // componentWillReceiveProps(np) {
  //   if (np.match.params.position !== this.routeParam.position) {
  //     scrollToComponent(this.refs[np.match.params.position], {
  //       offset: -55,
  //       align: "top",
  //       duration: 500
  //     });
  //   }
  //   if (JSON.stringify(np.match.params) !== JSON.stringify(this.routeParam)) {
  //     this.routeParam = np.match.params;
  //   }
  // }
  // renderCursos() {
  //   return json.map((item, i) => {
  //     return (
  //       <div ref={item.ref}>
  //         <Tarjetas text={item.text} title={item.title} />
  //       </div>
  //     );
  //   });
  // }
  render() {
    return (
      <div className="navMargin" style={{ height: "100%" }}>
        <section
          style={{
            paddingTop: "2%",
            backgroundColor: "#b3c6cf",
            display: "flex",
            flexDirection: "column",
            height: "auto",
            minHeight: "100%"
          }}
        >
          <p
            style={{
              color: "#352a35",
              textAlign: "center",
              fontSize: "60pt",
              fontWeight: "Bold"
            }}
          >
            Cursos
          </p>
          <Image
            src={require("../../img/lineCursos.png")}
            style={{
              marginLeft: "auto",
              marginRight: "auto",
              display: "block"
            }}
            responsive
          />
          <div style={{ height: 25 }} />
          <div>
            <Row>
              <Link to="/cursos/tesis">
                <Col xs={12} md={4} style={{ marginTop: 40 }}>
                  <Image
                    src={require("../../img/curTesis.png")}
                    style={{
                      marginLeft: "auto",
                      marginRight: "auto",
                      display: "block"
                    }}
                    responsive
                  />
                </Col>
              </Link>
              <Link to="/cursos/equipos">
                <Col xs={12} md={4} style={{ marginTop: 40 }}>
                  <Image
                    src={require("../../img/curEquipos.png")}
                    style={{
                      marginLeft: "auto",
                      marginRight: "auto",
                      display: "block"
                    }}
                    responsive
                  />
                </Col>
              </Link>
              <Link to="/cursos/formacion">
                <Col xs={12} md={4} style={{ marginTop: 40 }}>
                  <Image
                    src={require("../../img/curFormacion.png")}
                    style={{
                      marginLeft: "auto",
                      marginRight: "auto",
                      display: "block"
                    }}
                    responsive
                  />
                </Col>
              </Link>
            </Row>
            <Row>
              <Link to="/cursos/redaccion">
                <Col xs={12} md={4} mdOffset={2} style={{ marginTop: 40 }}>
                  <Image
                    src={require("../../img/curRedaccion.png")}
                    style={{
                      marginLeft: "auto",
                      marginRight: "auto",
                      display: "block"
                    }}
                    responsive
                  />
                </Col>
              </Link>
              <Link to="/cursos/metodos">
                <Col xs={12} md={4} style={{ marginTop: 40 }}>
                  <Image
                    src={require("../../img/curMetodos.png")}
                    style={{
                      marginLeft: "auto",
                      marginRight: "auto",
                      display: "block"
                    }}
                    responsive
                  />
                </Col>
              </Link>
            </Row>
          </div>
        </section>
      </div>
    );
    // <div className="navMargin container">
    //   <h2>Cursos</h2>
    //   {this.renderCursos()}
    // </div>
  }
  // componentDidMount() {
  //   var self = this;
  //   setTimeout(() => {
  //     scrollToComponent(self.refs[self.routeParam.position], {
  //       offset: -50,
  //       align: "top",
  //       duration: 500
  //     });
  //   }, 500);
  // }
  componentWillUnmount() {}
}



// WEBPACK FOOTER //
// ./src/views/cursos/index.js